import React, { useEffect, useRef } from 'react';
import Spacing from '../Spacing';
import About from '../About';

export default function AnaSayfa() {
  const splitVideoRef = useRef(null);


  useEffect(() => {
    const el = splitVideoRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!splitVideoRef.current) return;
          if (entry.isIntersecting) {
            const playPromise = splitVideoRef.current.play?.();
            if (playPromise?.catch) playPromise.catch(() => { });
          } else {
            splitVideoRef.current.pause?.();
          }
        }
      },
      { threshold: 0.6 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <main className="ana-sayfa-bg">
      {/* Main banner */}
      <section
        id="main-banner"
        className="mb-5"
        role="img"
        aria-label="Konf Banner"
        style={{
          backgroundImage: "url('/images/konf_banner.jpeg')",
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center top',
        }}
      >
        <img
          src="/images/konf_logo.png"
          alt="Konf Logo"
          className="ana-mobile-banner-logo"
        />
      </section>

      <div className="ana-mobile-first-logo" aria-hidden="true">
        <img src="/images/Logo%20vek-cropped.svg" alt="" />
        <p className="logo-subtext">AQI PEGASOS RESORT HOTEL</p>
        <p className="logo-subtext">1-3 MAYIS 2026</p>
      </div>

      {/* Mobile-only image section (we'll place your image here next) */}
      <section
        className="ana-mobile-image-section"
        aria-label="Ana sayfa mobil görsel bölümü"
      >
        <div className="container">
          <div className="ana-mobile-image-card">
            <img
              src="/images/rotaract_davet_yazisi_fixed_numbers.svg"
              className="ana-mobile-image-media"
              alt="Konferans davet görseli"
              loading="eager"
            />
            <div className="ana-mobile-image-logos" aria-label="Rotaract logoları">
              <img
                className="ana-mobile-image-logo"
                src="/images/Rotaract%20B%C3%B6lge%202430%20Logo%20Beyaz.png"
                alt="Rotaract Bölge 2430"
                loading="lazy"
                decoding="async"
              />
              <img
                className="ana-mobile-image-logo"
                src="/images/Rotaract Logo_EN21 (1).png"
                alt="Ankara Tandoğan Rotaract Kulübü"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Mobile-only video section */}
      <section
        className="ana-mobile-video-section"
        aria-label="Ana sayfa mobil tanıtım videosu"
      >
        <div className="container">
          <div className="ana-mobile-video-card">
            <video
              ref={splitVideoRef}
              className="ana-mobile-video"
              muted
              playsInline
              preload="metadata"
              controls
              aria-label="Tanıtım videosu"
            >
              <source src="/images/tanitim_video_eski.mp4" type="video/mp4" />
            </video>
          </div>
        </div>
      </section>

      {/* About Section */}
      <div className="ana-about-mobile-textonly">
        <About
          thumbnail="/images/konf_logo.png"
          uperTitle="center"
          title="Bu Masalı Beraber Yazıyoruz"
          subTitle={`Hani masallar daha ilk cümlesinden bizleri içine çeker ya; biz de bu büyülü hissi tüm dostlarımıza yaşatma hayaliyle yola çıktık. Ve şimdi, bir peri dokunuşu kadar sıcak Alanya güneşinin altında, bir arada olmanın tadını çıkaracağımız o günler için geri sayım başladı! Her Rotaractörün kendi masalının kahramanı olduğu bu yolculukta, tüm kahramanlarla bu büyük buluşmada bir araya geliyoruz.\n\nUzun bir dönem boyunca verdiğimiz emeklerin, hayata geçirdiğimiz projelerin ve liderlik yolculuğumuzun ışıltılı finaline sizleri davet etmenin heyecanı içerisindeyiz. Paylaştığımız her kahkahayı ve kurduğumuz her bağı, bu masalın en güzel hatıraları olarak yanımızda taşımak için sabırsızlanıyoruz. Bir Zamanlar Konferansta görüşmek üzere!`}
        />
      </div>

      <Spacing lg="80" md="60" />

      <Spacing lg="80" md="60" />





      <div className="container">
        <div className="text-center mt-4 mb-4 mx-auto" style={{ maxWidth: '480px' }}>
          <div className="d-flex align-items-center justify-content-center mb-3">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '8px' }}>
              <circle cx="12" cy="12" r="12" fill="#00e676"/>
              <path d="M10.2 15.6l-3.6-3.6 1.4-1.4 2.2 2.2 5.8-5.8 1.4 1.4-7.2 7.2z" fill="#ffffff"/>
            </svg>
            <span style={{ color: '#fff', fontWeight: 600, fontSize: '1.1rem' }}>Güvenli Ödeme</span>
          </div>
          <a href="https://www.paratika.com.tr" target="_blank" rel="noopener noreferrer">
            <img
              src="/images/paratika-sanal-pos-beyaz-logo.png"
              alt="Paratika Sanal POS"
              style={{ maxHeight: '48px', marginBottom: '12px' }}
            />
          </a>
          <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.85rem', margin: 0 }}>
            Ödeme işlemleri TCMB faaliyet onaylı ödeme kuruluşu{' '}
            <a href="https://www.paratika.com.tr" target="_blank" rel="noopener noreferrer" style={{ color: '#7c4dff' }}>
              Paratika
            </a>
            'nın güvenli altyapısı üzerinden gerçekleşmektedir.
          </p>
        </div>
      </div>

      <Spacing lg="80" md="60" />
    </main>
  );
}
